import { callApi } from '@/api/apibase'

export const fetchVehicleInformation = function (registrationNumber) {
  return callApi('GET',`/api/external/greencourse/GetCustomerRegistrationVehicleInformation?registrationNumber=${encodeURIComponent(registrationNumber)}`)
}
